import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=817a5c7e&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=817a5c7e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817a5c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('817a5c7e')) {
      api.createRecord('817a5c7e', component.options)
    } else {
      api.reload('817a5c7e', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=817a5c7e&scoped=true", function () {
      api.rerender('817a5c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/rubric/form/components/Questions.vue"
export default component.exports